export enum EndpointProductName {
  SIGN_TIME_WEB = 'Sorenson Videophone FBC WebRTC',
  SIGN_TIME_IOS = 'Sorenson Videophone FBC iOS',
}
